import React, { useContext } from "react";
import { AppContext } from "../../context";
import FacilityRow from "./FacilityRow";

function Facilities({ store }) {
  const info = useContext(AppContext);
  return (
    <div className="ahp-associate-banner" style={{ marginBottom: 20 }}>
      <div style={{ fontSize: "2rem", fontWeight: 900, marginBottom: 16 }}>
        {info.t("popularFacilities").toUpperCase()}
      </div>
      {store?.facilities?.map((facility, index) => (
        <FacilityRow facility={facility} key={index} />
      ))}
    </div>
  );
}

export default Facilities;
